import React from "react"

function Paragraph({ text, classes }) {
    return <p className={`${classes}`}>{text}</p>
}

export default Paragraph
